import { type ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { PageTransition } from './PageTransition';

interface ClassicPageLayoutProps {
  children: ReactNode;
}

/**
 * Layout classique : Header plein + Footer complet.
 * Utilisé par toutes les pages de contenu (landing, blog, légal, etc.).
 * Le padding bas sticky est géré par MobileStickyCta (spacer conditionnel),
 * pas ici — évite un trou vide quand le sticky est absent.
 */
export function ClassicPageLayout({ children }: ClassicPageLayoutProps) {
  return (
    <>
      <Header />
      <main id="main" className="min-h-[60vh]">
        <PageTransition>{children}</PageTransition>
      </main>
      <Footer />
    </>
  );
}
